import React, {Component} from 'react';
import { Tabs, Modal, message } from 'antd';
import writeStory from './write.png';
import {Scrollbars} from "react-custom-scrollbars";
import {getNewsActivityById, loadInterviewResource} from "../../actions/interview";
import { Spin,Empty,Avatar,Icon } from 'antd/lib/index';
import './interview.css';
import {getCandidateByUuid} from "../../actions";
import {getById} from "../../actions/newsActivityAction";
import NewsActivityPublishPlatform from "./NewsActivityPublishPlatform";
import _ from 'lodash';


const { TabPane } = Tabs;
const { confirm } = Modal;
class NewsActivityWriteStory extends Component {
    constructor(props){
        super(props);
        this.childCpWrapper = React.createRef();

        this.state = {

        load:true,//是否加载完成
        story:null,
        editAuth:false,//稿件编辑权限
        selectPlatForm: [],
        allplatForm:[],
        activeKey: '',
        visible: false,
            taskDetailStatus:''
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.data && nextProps.data.id > 0) {
            this.loadStory(nextProps.data.id);
            this.getNewsActivityById(nextProps.data.id)
        }
    }

    componentDidMount() {//这里是去判断看看是不是要刷新父元素，因为稿件如果提交了，那么就不能上传图片或者视频
        this.getStory('0',true);
    }

    getStory = (type,isRefreshParent) => {
        console.log(this.props.data)
        if(this.props.data && this.props.data.id > 0) {
            this.loadStory(type,this.props.data.id,isRefreshParent);
            this.getNewsActivityById(this.props.data.id)
        }

    }
    getNewsActivityById(id){
        getNewsActivityById(id , (res)=>{
            this.setState({taskDetailStatus:res.status});
        });
    }


    loadStory(type, id, isRefreshParent){
        if(id > 0){
            //加载采访任务的资源
            window.loading.show();
            loadInterviewResource(id, (res)=>{
                window.loading.hide();
                let story = null;
                let isRefresh = false;
                let activeKey = this.state.activeKey;
                if(res && res.storyList && res.storyList.length > 0){
                    story = res.storyList;
                }
                if (story && story.length > 0) {
                    for (let i = 0; i < story.length; i++) {
                        this.loadStoryAuth(story, i, story[i], this.props.currentUser);
                    }
                    if(isRefreshParent && id && id > 0){
                        getById(id).then(interview=>{
                            if(interview.status === 3 || interview.status === 4){
                                this.props.refreshParentMethod();
                            }
                        });
                    }   
                }
                if(type === 'add'){
                    activeKey = story && story.length ? story[story.length -1].id.toString() : 0
                } 
                if(type === '0'){
                    activeKey = ( story && story.length > 0 ) ? story[0].id.toString() : 0
                }
                this.setState({
                    load:true,
                    activeKey,
                    story,
                })
            })
        }
    }

    loadStoryAuth(storyList,index, story, currentUser, callBack){
        let storyResult = storyList;
        storyResult[index].edit = true;
        if(story && story.user && currentUser && story.statusName==="草稿"){
            storyResult[index].edit = story.user.account === currentUser.account
        }
        if( storyResult[index].edit){
            if(story && story.statusName!=="草稿"){
                storyResult[index].edit = false;
                getCandidateByUuid(story.uuid).then(res=>{
                    if(res.state){//说明是在流程中的
                        res.data && res.data.map(user=>{
                            if(user.userId === currentUser.account){
                                storyResult[index].edit = true;
                                this.setState({story:storyResult}, ()=>{
                                    console.log('11',this.state.story)
                                });
                            }
                        })
                    }
                    if(callBack){
                        callBack();
                    }
                })
            }else{
                this.setState({story:storyResult}, () => {
                    console.log('22',this.state.story)
                });
            }
        }
    }

    getPublishData = (type, selectPlatForm) => {
        if(type === 'all'){
            this.setState({
                allplatForm: selectPlatForm,
                selectPlatForm
            })
        } else {
            this.setState({
                selectPlatForm
            })
        }
      
    }

    editStory(interviewId, storyId){ 
        let url = "/cm-sites/pms/addContribute/addContributeNews.html?eiditStoryId="+storyId+"&interviewId="+interviewId+"&actButtonId=9&isShowMainColumnSetBtn=false&attribute=original&passMediaCodes=";
        console.log(url)
        let that = this;
        window.openFull(url, "稿件编辑", function () {
            that.getStory(true);
        }, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, undefined,function () {
            that.getStory('edit',true);
        })
    }

    addStory(interviewId, storyId, platform){
        const selectPlatForm = platform;
        let submitMediaCodes = _.map(selectPlatForm, 'code'); 
        let url = "/cm-sites/pms/addContribute/addContributeNews.html?eiditStoryId="+storyId+"&interviewId="+interviewId+"&actButtonId=9&isShowMainColumnSetBtn=false&attribute=original&passMediaCodes=" + "&submitMediaCodes=" +submitMediaCodes.join(',');
        console.log(url)
        let that = this;
        window.openFull(url, "稿件编辑", function () {
            that.getStory(true);
        }, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, undefined,function () {
            that.getStory('add',true);
        })
    }

    changeActiveKey = (activeKey) => {
        if(activeKey !== '0'){
            this.setState({
                activeKey,
            })
        } else {
            let _this = this;

            _this.addStory(_this.props.data.id,0, _this.state.allplatForm);
            //去掉弹出，直接跳转到稿件
            /*confirm({
                title: '选择提交媒体',
                okText: '确定',
                cancelText: '跳过',
                onOk() {
                    _this.setState({
                        visible:true
                    });
                },
                onCancel() {
                    //直接跳转到写稿页面
                    _this.addStory(_this.props.data.id,0, _this.state.allplatForm) 
                }
              });*/
        }
    }

    handleSelectMediaOk = () => {
        let selectPlatForm = this.state.selectPlatForm;
        if(selectPlatForm.length === 0){
            message.error('至少选择一个提交媒体！');
            return;
        }
        this.setState({
            visible: false,
            selectPlatForm: this.state.allplatForm,
        }, () => {
            //选择媒体后跳转到写稿页面
            this.addStory(this.props.data.id,0, selectPlatForm); 
            this.newsActivityPublishPlatform.setSelectedPlatFormData({simpleMedias: this.state.allplatForm});  
        })
    }

    handleCancel = () => {
        this.setState({
            visible: false, //不做任何操作
            selectPlatForm: this.state.allplatForm,
        },()=>{
            this.newsActivityPublishPlatform.setSelectedPlatFormData({simpleMedias: this.state.allplatForm});
        })
    }

    render() {
        let isShowLQBtn = false;
        let addButton = false;

        let nowDate=new Date().getTime();//当前时间
        // data. status <3  任务在在3以前  并且没有超期
        let row = this.props.data;
        let activityTime;//活动时间
        if(row&&row.endDate){
            activityTime=row.endDate.time;
        }else{
            activityTime=row.interviewEndDate?row.interviewEndDate.time:0;//活动时间
        }
        if(this.props.data.status<4){

            let overdue=true;
            if(activityTime>0&&activityTime<nowDate){
                overdue=false;
            }

            if(this.props.data.status===1&&overdue){
                this.props.data.interviewJointers && this.props.data.interviewJointers.map(item=>{
                    if(item.account && this.props.currentUser && this.props.currentUser.account && (item.account === this.props.currentUser.account)){
                        if(!isShowLQBtn){
                            if(item.interviewRole == 1){//必须是文字记者
                                addButton = true;
                                isShowLQBtn = (parseInt(item.status) < 3);//1是未领取 2是进行中
                            }
                        }
                    }
                });
            }else if(this.props.data.status!==1){
                this.props.data.interviewJointers && this.props.data.interviewJointers.map(item=>{
                    if(item.account && this.props.currentUser && this.props.currentUser.account && (item.account === this.props.currentUser.account)){
                        if(!isShowLQBtn){
                            if(item.interviewRole == 1){//必须是文字记者
                                addButton = true;
                                isShowLQBtn = (parseInt(item.status) < 3);//1是未领取 2是进行中
                            }
                        }
                    }
                });
            }
        }


       /* this.props.data.interviewJointers && this.props.data.interviewJointers.map(item=>{
            if(item.account && this.props.currentUser && this.props.currentUser.account && (item.account === this.props.currentUser.account)){
                if(!isShowLQBtn){
                    if(item.interviewRole == 1){//必须是文字记者
                        addButton = true
                        isShowLQBtn = (parseInt(item.status) < 3);//1是未领取 2是进行中
                    }
                }
            }
        });*/

        let editAuth = this.state.editAuth;
        const { story, activeKey, visible } = this.state;
        console.log('render',isShowLQBtn)
        return (
            <>
            <div style={{backgroundColor:"#f4f6fc",padding:"20px",width:"100%"}}>
               
                {this.state.load?(this.state.story && this.state.story.length > 0 ?
                <div className="story-tab" >
                      <Tabs className="story-tab" type="card" tabPosition="top" activeKey={activeKey} onTabClick={this.changeActiveKey}>
                    {
                        story.map((item) => {
                            let submitStatusName = '';
                            if (item.copyStorys.length > 0) {
                                item.copyStorys.forEach(copyStoryItem => {
                                    if (copyStoryItem.statusName === '发布') {
                                        submitStatusName = '已发布';
                                        return;
                                    }
                                });
                                if (submitStatusName !== '已发布') {
                                    if (item.statusName === '发布') {
                                        submitStatusName = '已发布';
                                    } else {
                                        submitStatusName =item.statusName? item.statusName:'';
                                    }
                                }
                            }else{
                                submitStatusName =item.statusName? item.statusName:'';
                            }
                            item.statusName=submitStatusName;
                            return(
                            <TabPane key={item.id.toString()} tab={<span style={{ maxWidth: '124px', overflow:'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',/*lineHeight:'14px',*/ display: 'inline-block'}}>{item.title}</span>}>
                                <Scrollbars
                                    style={{ height: 600 }}
                                >
                                    <Story  editClick={(storyId) => { this.editStory(this.props.data.id, storyId) }} story={item} />
                                </Scrollbars>
                            </TabPane>
                        )})
                        
                    }
                    {
                        addButton&&(this.state.taskDetailStatus!==4) ? <TabPane key="0" tab={<span style={{ maxWidth: '124px', overflow:'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',/*lineHeight:'14px',*/ display: 'inline-block'}}><Icon  type="plus"/></span>} onClick={this.addStory}></TabPane> : null
                    }
                    
                    <style>
                    {
                        `
                        .story-tab .ant-tabs ant-tabs-top story-tab ant-tabs-card ant-tabs-no-animation .ant-tabs-bar ant-tabs-top-bar ant-tabs-card-bar{
                            background: #fff;
                            padding-top: 10px;
                        }
                        .story-tab .ant-tabs-content ant-tabs-content-no-animated ant-tabs-top-content ant-tabs-card-content{
                            height: 540px;
                            background: #fff;
                            padding: 10px;
                        }
                        `
                    }
                </style>
                </Tabs>
              
                </div>
                // <Story edit={editAuth} editClick={(storyId)=>{this.editStory(this.props.data.id, storyId)}} story={this.state.story} />
                :(isShowLQBtn?<div style={{width:"100%", height:"600px",}}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', margin:'0 20px', padding: '20px 0',background:"#fff"}}>
                            <img src={writeStory} width={120} />
                            <div style={{backgroundColor: "#7c53c9",
                                marginTop:"30px",
                                width:"150px",
                                height: "38px",
                                textAlign:"center",
                                boxShadow: "0px 10px 30px 0px rgba(208, 208, 208, 0.2)",
                                borderRadius: "19px"}}>
                            <span onClick={()=>this.addStory(this.props.data.id, 0, this.state.selectPlatForm)} style={{
                                width:"96px",
                                cursor:"pointer",
                                height: "15px",
                                fontFamily: "MicrosoftYaHei",
                                fontSize: "16px",
                                fontWeight: "normal",
                                fontStretch: "normal",
                                lineHeight: "38px",
                                letterSpacing: "0px",
                                color: "#fefeff"
                            }}>创建稿件</span>
                            </div>
                        </div>
                        {/*移除创建时候媒体平台*/}
                       {/* <NewsActivityPublishPlatform wrappedComponentRef={(test)=> this.platformRef = test } hasOperate={true} data={this.props.data} getPublishData={this.getPublishData}/>*/}
                        </div>:<div style={{width:"100%", backgroundColor:"#fff", padding:"32px 40px", height:"400px",
                            /*flex 布局*/
                            display: "flex",
                            /*实现垂直居中*/
                            alignItems: "center",
                            /*实现水平居中*/
                        justifyContent: "center",}}><Empty/></div>)):<div style={{width:"100%", backgroundColor:"#fff", padding:"32px 40px", height:"400px",
                            /*flex 布局*/
                            display: "flex",
                            /*实现垂直居中*/
                            alignItems: "center",
                            /*实现水平居中*/
                        justifyContent: "center",}}><Spin/></div>}
                         <Modal
              title="选择提交媒体"
              visible={visible}
              onOk={this.handleSelectMediaOk}
              onCancel={this.handleCancel}
              width="940px"
              className="select-media-modal"
            > 
             <NewsActivityPublishPlatform  ref={(ref) => { this.newsActivityPublishPlatform = ref;}} hasOperate={true} data={this.props.data} getPublishData={this.getPublishData}/>
            </Modal>
            </div>
           
            {/* 跳过时需要默认选择所有媒体 */}
            <div style={{ display: 'none'}}> 
                <NewsActivityPublishPlatform hasOperate={true} data={this.props.data} getPublishData={this.getPublishData}/>
            </div>
           </>
        );
    }
}

export class Story extends Component{
    render() {
        let sex = this.props.story.user.sex;
        let photo = "images/header_boys.png";
        let name = this.props.story.user.name;
        let changeDate = this.props.story.changeDate;
        if(this.props.story.user.photoUrl){
            photo = this.props.story.user.photoUrl
        }else{
            if(sex === 2){
                photo = "/cm-sites/images/header_girls.png";
            }
        }
        let content = this.props.story.content;
        let video_res = /<embed[^>]*vsbmp4video="true"[^>]*>/g;
        if(video_res.test(content)){
            content = content.replace(video_res, function (match) {
                return match.replace("<embed","<video controls").replace(/ src=/," old_src=").replace(/ ue_src=\"([^\"]*)/," src=\"$1?.mp4");
            })
        }

        let audio_res = /<embed[^>]*vsbmp3audio="true"[^>]*>/g;
        if(audio_res.test(content)){
            content = content.replace(audio_res, function(embedHTML){
                let realSrc = embedHTML.replace(/.*vsb_data="([^"]*)".*/, "$1");
                embedHTML = embedHTML.replace(/(src=")[^"]*"/, "$1"+realSrc+"?v="+new Date().getTime()+"\"");
                return embedHTML.replace("<embed","<audio controls");
            });
        }
        return <div style={{width:"100%", backgroundColor:"#fff", padding:"32px 40px", /*height: '100%'*/}}>
            <div style={{display:'flex'}}>
                <div style={{width:800,fontWeight:'bold'}}>
                    <div className={"new-activity-story-title text-pointer"} style={{ justifyContent: 'space-between'}} title={this.props.story.title}>{this.props.story.title}</div>
                </div>
                <div style={{position:'absolute',right:50}}>
                    <span style={{color: 'rgba(135,146,179)',lineHeight: '30px',fontWeight:'bold',fontSize:'14px'}}>{this.props.story.statusName ? this.props.story.statusName: ''}</span>
                </div>
            </div>
            <table cellSpacing={0} cellPadding={0} border={0} width={"100%"}>
                <tbody>
                    <tr>
                        <td rowSpan={2} width={56}>
                            <Avatar src={photo} style={{marginRight:"10px"}} size={50} />
                        </td>
                        <td align={"left"}><span className={"new-activity-story-user-name"}>{name}</span></td>
                        <td rowSpan={2} align={"right"}>
                            {this.props.story.edit?<div><Icon type="edit" style={{fontSize:"15px"}} /><span onClick={()=>{this.props.editClick(this.props.story?this.props.story.id:0)}} className={"new-activity-story-edit"}>编辑</span></div>:""}
                        </td>
                    </tr>
                    <tr>
                        <td><span className={"new-activity-story-update-time"}>{window.formatDate(changeDate)}</span></td>
                    </tr>
                </tbody>
            </table>
            <div style={{marginTop:"20px"}} dangerouslySetInnerHTML={{__html:content}}></div>
        </div>
    }
}

Story.defaultProps={
    editClick:()=>{}
}

NewsActivityWriteStory.defaultProps = {
    data:{}
}
export default NewsActivityWriteStory;